import { Link } from 'react-router-dom';
import { useState } from 'react';

const EnjoyPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCompanyOpen, setIsCompanyOpen] = useState(false);

  const products = [
    {
      id: 1,
      name: 'Achocolatado',
      weight: '400g',
      category: 'Bebidas',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/46119f5f1a5f8106da60b5a5f42eb761.jpeg',
      description: 'Achocolatado cremoso e saboroso, perfeito para toda a família.'
    },
    {
      id: 2,
      name: 'Bolo Laranja',
      weight: '400g',
      category: 'Bolos',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/a698340eeaa6c21d914163e3eb518b33.jpeg',
      description: 'Mistura para bolo sabor laranja, fácil de preparar e delicioso.'
    },
    {
      id: 3,
      name: 'Bolo Baunilha',
      weight: '400g',
      category: 'Bolos',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/f4f9d9426b503a929a8369aa46a6fde8.jpeg',
      description: 'Mistura para bolo sabor baunilha, clássico e irresistível.'
    },
    {
      id: 4,
      name: 'Bolo Chocolate',
      weight: '400g',
      category: 'Bolos',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/853e1b71bea36c83f7686d0f85cb7e99.jpeg',
      description: 'Mistura para bolo sabor chocolate, rico e cremoso.'
    },
    {
      id: 5,
      name: 'Bolo Coco',
      weight: '400g',
      category: 'Bolos',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/6da6fc690943f597ca5015c59810f72e.jpeg',
      description: 'Mistura para bolo sabor coco, tropical e saboroso.'
    },
    {
      id: 6,
      name: 'Caldo de Carne',
      weight: '50g',
      category: 'Caldos',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/51da6e09acfb96e40a2b8980e2ea7c49.jpeg',
      description: 'Caldo de carne concentrado para realçar o sabor dos seus pratos.'
    },
    {
      id: 7,
      name: 'Gelatina Sachê Morango',
      weight: '25g',
      category: 'Gelatinas',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/cba45a749e0e765ce4e456f51bad3187.jpeg',
      description: 'Gelatina sabor morango em sachê, prática e deliciosa.'
    },
    {
      id: 8,
      name: 'Gelatina Sachê Uva',
      weight: '25g',
      category: 'Gelatinas',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/86da864d176bba3eff022707c881b992.jpeg',
      description: 'Gelatina sabor uva em sachê, refrescante e saborosa.'
    },
    {
      id: 9,
      name: 'Gelatina Sachê Abacaxi',
      weight: '25g',
      category: 'Gelatinas',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/ceaa3c584050678386c808505210acc1.jpeg',
      description: 'Gelatina sabor abacaxi em sachê, tropical e refrescante.'
    }
  ];

  const categories = ['Todos', 'Bebidas', 'Bolos', 'Caldos', 'Gelatinas'];

  const filteredProducts = selectedCategory === 'Todos' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  return (
    <div className="min-h-screen">
      {/* Custom Header for Enjoy Page */}
      <header className="bg-white shadow-lg sticky top-0 z-50">
        {/* Top Bar - Red */}
        <div className="bg-red-600 text-white py-2">
          <div className="max-w-7xl mx-auto px-4 flex justify-between items-center text-sm">
            <div className="flex items-center space-x-4">
              <span className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                (19) 3852-8200
              </span>
              <span className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                contato@sustentare.com.br
              </span>
            </div>
            <div className="flex items-center space-x-4">
              <a href="https://www.facebook.com/sustentare.brasil" target="_blank" rel="noopener noreferrer" className="hover:text-red-200 transition-colors">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="https://www.instagram.com/sustentarealimentos" target="_blank" rel="noopener noreferrer" className="hover:text-red-200 transition-colors">
                <i className="ri-instagram-fill"></i>
              </a>
              <a href="https://www.youtube.com/user/tecnutrifoodservice" target="_blank" rel="noopener noreferrer" className="hover:text-red-200 transition-colors">
                <i className="ri-youtube-fill"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Main Header */}
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            {/* Logo Enjoy */}
            <Link to="/enjoy" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/8fe4f6137f6a8f5fc86da76ab779e946.png" 
                alt="Enjoy Logo" 
                className="h-12 w-auto"
              />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              <Link to="/" className="text-gray-700 hover:text-red-600 font-medium transition-colors whitespace-nowrap">
                Home
              </Link>
              
              <div className="relative group">
                <button className="text-gray-700 hover:text-red-600 font-medium transition-colors flex items-center whitespace-nowrap cursor-pointer">
                  Marcas
                  <i className="ri-arrow-down-s-line ml-1"></i>
                </button>
                
                <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl border py-4 z-50 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                  <Link to="/enjoy" className="block px-6 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors">
                    Enjoy
                  </Link>
                  <Link to="/nutrare" className="block px-6 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors">
                    Nutrare
                  </Link>
                </div>
              </div>

              <a href="https://wa.me/5519992303708" target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-red-600 font-medium transition-colors whitespace-nowrap">
                Contato
              </a>
            </nav>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden text-gray-700 hover:text-red-600 transition-colors"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="lg:hidden py-4 border-t">
              <nav className="flex flex-col space-y-4">
                <Link 
                  to="/" 
                  className="text-gray-700 hover:text-red-600 font-medium transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Home
                </Link>
                
                <div>
                  <button 
                    className="text-gray-700 hover:text-red-600 font-medium transition-colors flex items-center w-full cursor-pointer"
                    onClick={() => setIsCompanyOpen(!isCompanyOpen)}
                  >
                    Marcas
                    <i className={`ml-1 ${isCompanyOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
                  </button>
                  {isCompanyOpen && (
                    <div className="ml-4 mt-2 flex flex-col space-y-2">
                      <Link 
                        to="/enjoy" 
                        className="text-gray-600 hover:text-red-600 transition-colors"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        Enjoy
                      </Link>
                      <Link 
                        to="/nutrare" 
                        className="text-gray-600 hover:text-red-600 transition-colors"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        Nutrare
                      </Link>
                    </div>
                  )}
                </div>
                
                <a 
                  href="https://wa.me/5519992303708"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:text-red-600 font-medium transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Contato
                </a>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <section 
        className="relative min-h-[60vh] flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(139, 0, 0, 0.85), rgba(220, 20, 60, 0.85)), url('https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/8fe4f6137f6a8f5fc86da76ab779e946.png')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-red-900/20 via-red-700/10 to-red-900/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 py-20 text-center w-full">
          <div className="mb-6">
            {/* Logo Enjoy */}
            <div className="flex justify-center mb-8">
              <img 
                src="https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/a53f7918c77c98e1cda5a1b622d2e652.png" 
                alt="Enjoy Logo" 
                className="h-32 w-auto"
              />
            </div>
            <h1 className="text-5xl lg:text-7xl font-bold text-white leading-tight mb-6">
              Sabor e Praticidade
            </h1>
            <p className="text-xl lg:text-2xl text-white/95 max-w-3xl mx-auto leading-relaxed">
              Produtos práticos e saborosos para o seu dia a dia
            </p>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-20 bg-gradient-to-b from-orange-50 to-white">
        <div className="max-w-7xl mx-auto px-4">
          {/* Section Header */}
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Nossa Linha de Produtos
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-10">
              Conheça toda nossa linha de produtos alimentícios desenvolvidos 
              com qualidade e sabor incomparáveis.
            </p>

            {/* Category Filter */}
            <div className="flex flex-wrap justify-center gap-3">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-6 py-3 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                    selectedCategory === category
                      ? 'bg-orange-600 text-white shadow-lg scale-105'
                      : 'bg-white text-gray-700 hover:bg-orange-100 hover:text-orange-600 shadow-md'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
            {filteredProducts.map((product) => (
              <div 
                key={product.id} 
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group hover:-translate-y-2"
              >
                <div className="aspect-square overflow-hidden bg-gradient-to-br from-orange-50 to-yellow-50">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="px-4 py-1.5 bg-orange-100 text-orange-600 text-sm font-semibold rounded-full">
                      {product.category}
                    </span>
                    <span className="text-gray-500 text-sm font-medium">
                      {product.weight}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-orange-600 transition-colors">
                    {product.name}
                  </h3>
                  <p className="text-gray-600 mb-5 leading-relaxed">
                    {product.description}
                  </p>
                  <Link
                    to={`/enjoy/produto/${product.id}`}
                    className="block w-full py-3 bg-gradient-to-r from-orange-600 to-orange-500 text-white font-semibold rounded-lg hover:from-orange-700 hover:to-orange-600 transition-all shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer text-center"
                  >
                    Ver Detalhes
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-red-900 to-red-600">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Quer conhecer mais sobre a Enjoy?
          </h2>
          <p className="text-xl text-red-100 mb-8 leading-relaxed">
            Entre em contato conosco e descubra como nossos produtos podem 
            transformar o seu negócio.
          </p>
          <a 
            href="https://wa.me/5519992303708"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-10 py-4 bg-white text-red-600 font-bold rounded-lg hover:bg-red-50 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap"
          >
            Fale Conosco
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </section>

      {/* Custom Footer for Enjoy Page */}
      <footer className="bg-gradient-to-br from-red-900 via-red-800 to-red-700 text-white">
        {/* Main Footer */}
        <div className="max-w-7xl mx-auto px-4 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Company Info */}
            <div className="lg:col-span-1">
              <div className="mb-6">
                <img 
                  src="https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/8fe4f6137f6a8f5fc86da76ab779e946.png" 
                  alt="Enjoy Logo" 
                  className="h-10 w-auto mb-4"
                />
                <p className="text-red-100 mb-6">
                  Produtos práticos e saborosos para o seu dia a dia.
                </p>
              </div>
              
              {/* Social Links */}
              <div className="flex space-x-4">
                <a 
                  href="https://www.facebook.com/sustentare.brasil" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-red-800 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors"
                >
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a 
                  href="https://www.instagram.com/sustentarealimentos" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-red-800 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors"
                >
                  <i className="ri-instagram-fill text-lg"></i>
                </a>
                <a 
                  href="https://www.youtube.com/user/tecnutrifoodservice" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-red-800 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors"
                >
                  <i className="ri-youtube-fill text-lg"></i>
                </a>
              </div>
            </div>

            {/* Products */}
            <div>
              <h3 className="text-xl font-semibold mb-6">Produtos</h3>
              <ul className="space-y-3">
                <li>
                  <button 
                    onClick={() => setSelectedCategory('Bebidas')}
                    className="text-red-100 hover:text-white transition-colors cursor-pointer text-left"
                  >
                    Bebidas
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => setSelectedCategory('Bolos')}
                    className="text-red-100 hover:text-white transition-colors cursor-pointer text-left"
                  >
                    Bolos
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => setSelectedCategory('Caldos')}
                    className="text-red-100 hover:text-white transition-colors cursor-pointer text-left"
                  >
                    Caldos
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => setSelectedCategory('Gelatinas')}
                    className="text-red-100 hover:text-white transition-colors cursor-pointer text-left"
                  >
                    Gelatinas
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-xl font-semibold mb-6">Contato</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <i className="ri-phone-line text-red-300 mt-1 mr-3"></i>
                  <div>
                    <p className="text-red-100">WhatsApp</p>
                    <a href="https://wa.me/5519992303708" target="_blank" rel="noopener noreferrer" className="text-white hover:text-red-200 transition-colors">
                      Clique aqui
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <i className="ri-mail-line text-red-300 mt-1 mr-3"></i>
                  <div>
                    <p className="text-red-100">E-mail</p>
                    <a href="mailto:contato@sustentare.com.br" className="text-white hover:text-red-200 transition-colors">
                      contato@sustentare.com.br
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-red-300 mt-1 mr-3"></i>
                  <div>
                    <p className="text-red-100">Endereço</p>
                    <p className="text-white">
                      Est. Mun. Fioravante Carlotti nº 1901<br />
                      Bairro Santa Tereza<br />
                      13920-314, Pedreira - SP
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-red-800">
          <div className="max-w-7xl mx-auto px-4 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-red-100 text-sm mb-4 md:mb-0">
                © 2025 Sustentare. Todos os direitos reservados.
              </p>
              <div className="flex items-center space-x-4">
                <a 
                  href="https://wa.me/19995563309"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-red-100 hover:text-white text-sm transition-colors"
                >
                  M.PLACIDINO
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default EnjoyPage;
